
    <div (click)="showMessage(mess.value)" *ngFor = "let mess of messages() | keyvalue" [ngStyle]="{'border-color': mess.value.TYPE == 'INFO' ? 'rgb(94, 137, 250)' : '#BF2F1A'}">
       <!-- {{mess.data}} -->

        <div class="messIcon" *ngIf="mess.value.TYPE == 'INFO'"></div>
        <!--img *ngIf="mess.value.TYPE == 'WARNING'" src="/assets/alert.png"  height="15%"-->

        <div class="warningIcon" *ngIf="mess.value.TYPE == 'WARNING'"></div>
        <!--<button *ngIf="mess.type == 'QUESTION'" id="reject" type="button">Odrzuć</button> -->
        <!--<button *ngIf="mess.type == 'NOTIFY'" id="ok" type="button">Potwierdź</button> -->
        <!--<button *ngIf="mess.type == 'QUESTION'" id="accept" type="button">Akceptuj</button> -->
    </div>
